import styled from 'styled-components'
import Color from './color'
import Font from './font'
import Size from './size'
import Stroke from './stroke'
import { SourceEditorCaptionStyle } from '../../types'
import { ICustomFont } from 'site/creation-tools/components/supercut/shared/types'

const Container = styled.div`
    display: flex;
    padding: 15px;
    padding-bottom: 0;

    > div {
        margin-right: 10px;
    }
    > div:last-child {
        margin-right: 0;
    }
`

type CaptionStyleOptionsProps = {
    captionStyle: SourceEditorCaptionStyle
    setCaptionStyle: (captionStyle: SourceEditorCaptionStyle) => void
    customFont: ICustomFont | undefined
}

const CaptionStyleOptions = ({ captionStyle, setCaptionStyle, customFont }: CaptionStyleOptionsProps) => {
    return (
        <Container>
            <Font captionStyle={captionStyle} setCaptionStyle={setCaptionStyle} customFont={customFont} />
            <Size captionStyle={captionStyle} setCaptionStyle={setCaptionStyle} />
            <Color captionStyle={captionStyle} setCaptionStyle={setCaptionStyle} />
            <Stroke captionStyle={captionStyle} setCaptionStyle={setCaptionStyle} />
        </Container>
    )
}

export default CaptionStyleOptions
